import IncotermsPageConfig from './incoterms/IncotermsPageConfig';
import PortPageConfig from './ports/PortPageConfig';
import UnitItemPageConfig from './unititems/UnitItemPageConfig';
import EquipmentPageConfig from './equipment/EquipmentPageConfig';
import CurrencyPageConfig from './currencies/CurrencyPageConfig';
import ProjectKPIPageConfig from './projectkpis/ProjectKPIPageConfig';

const masterdataConfig = [IncotermsPageConfig, PortPageConfig, UnitItemPageConfig, EquipmentPageConfig, CurrencyPageConfig, ProjectKPIPageConfig];

export default masterdataConfig;
